import React, { Fragment, useContext, useState, useEffect } from 'react'
import { Transition, Menu } from '@headlessui/react'
import AuthContext from '../context/AuthContext'
import { Link, useLocation } from 'react-router-dom'
import OImage from './reusable/OImage'
import {
  MdNotificationsActive,
  MdOutlineNotificationsNone
} from 'react-icons/md'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import { t } from 'i18next'
const TopNavBar = () => {
  const { logoutUser, user, handleSidebar, pageName, updatePageName } =
    useContext(AuthContext)
  const location = useLocation()
  const [notification, setNotification] = useState(false)

  const getNotification = async () => {
    try {
      const path = apiPath.getNotification
      const result = await apiGet(path, {})
      setNotification(result?.data?.results?.unreadNotification)
    } catch (error) {
      console.log('error:', error)
    }
  }

  const handelApiCall = () => {
    getNotification()
  }

  useEffect(() => {
    getNotification()
  }, [location.pathname])

  const handleLogout = () => {
    if (window.confirm('Are you sure to logout?')) {
      logoutUser()
    }
  }
  return (
    <div className='linHeader border-b-[1px] py-4 px-4 md:px-8'>
      <header className='bg-white items-center flex'>
        <div className='mr-4' onClick={() => handleSidebar()}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth='1.5'
            stroke='currentColor'
            className='w-6 h-6'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
            />
          </svg>
        </div>

        <div className='page_heading flex items-center gap-2 text-sm'>
          {/* <h1 className='font-medium text-[#000] text-lg font-bold'>
            {pageName}
          </h1> */}

          <Link to='/'><span className='text-[#8FC150]'>Home</span></Link>
          <span>/</span> 
          <span className='text-[#595959]'>{pageName}</span>
        </div>
        <Menu
          as='div'
          className='relative inline-block text-left hover:text-LightBlue sidebar_dropdown ml-auto'
        >
          <div>
            {/* <Menu.Button className='flex relative items-center w-full text-white active:text-LightBlue hover:bg-white hover:text-LightBlue group'> */}
            <Menu.Button className='flex relative items-center w-full  active:text-LightBlue hover:bg-white hover:text-LightBlue group'>
              <span title={t('O_NOTIFICATION')}>
                <div className='flex justify-end '>
                  {notification ? (
                    <Link
                      to='/notification-list'
                      className='mr-4 relative'
                      onClick={() => handelApiCall()}
                    >
                      <MdNotificationsActive className='w-6 h-6' />
                      <span className='absolute top-0 right-0 w-0.5 h-0.5 bg-red-500 flex justify-center items-center rounded-full text-white p-1.5 d-block text-xs font-bold'></span>
                    </Link>
                  ) : (
                    <Link to='/notification-list' className='mr-4 relative'>
                      <MdOutlineNotificationsNone className='w-6 h-6' />
                    </Link>
                  )}
                  {/* <Link to='/notification-list' className='mr-4 relative '>
                    {isNotification ? (
                      <MdNotificationsActive className='w-6 h-6' />
                    ) : (
                    <MdNotificationsNone className='w-6 h-6' />
                    )}
                  </Link> */}
                </div>
              </span>
              <div className='profile flex items-center ml-auto md:mr-10 mr-2'>
                <figure className='inline-block overflow-hidden rounded-full'>
                  <OImage
                    src={user?.profilePic}
                    fallbackUrl='/images/user.png'
                    className='w-[40px] h-[40px] inline'
                    alt=''
                  />
                </figure>
                <small className='block text-sm text-slate-900 ml-2 md:block hidden'>
                  {user?.firstName} {user?.lastName}
                </small>
              </div>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-10'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'
          >
            <Menu.Items className='absolute z-10 text-left min-w-[200px]  right-2 content divide-y divide-gray-100  bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
              <div className=''>
                <Menu.Item onClick={() => updatePageName('Edit profile')}>
                  {({ active }) => (
                    <Link
                      to='/profile'
                      className={`${
                        active ? 'bg-violet-500 text-white' : 'text-gray-900'
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Edit profile
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item onClick={() => updatePageName('Change password')}>
                  {({ active }) => (
                    <Link
                      to='/change-password'
                      className={`${
                        active ? 'bg-violet-500 text-white' : 'text-gray-900'
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Change password
                    </Link>
                  )}
                </Menu.Item>
              </div>
              <div className=''>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleLogout}
                      className={`${
                        active ? 'bg-violet-500 text-white' : 'text-gray-900'
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Logout
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>

        {/* <a
                    href='#'
                    className='bg-[#8FC150] flex text-sm px-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150]'
                >
                    <img src='./images/google-play.svg' className='pr-2' alt='' />
                    Download App
                </a> */}
      </header>
    </div>
  )
}

export default TopNavBar
